<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import {swal, imageError} from '../../../helpers/handle_error.js';
import AlertError from '@/components/alert_error'
import About from '../../../model/about.js';
import { dataURLtoFile } from '../../../helpers/helper_func'
import { VueContentLoading } from 'vue-content-loading';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import InputTag from 'vue-input-tag';
import VueEditor from '@/components/Vue2Editor'

export default {
  page: {
    title: "من نحن",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, AlertError,  VueContentLoading, Cropper, InputTag, VueEditor },
  data() {
    return {
      // limit tag
      limit:10,

      title: "من نحن",
      items: [
        {
          text: "الرئيسية",
          href: "/",
        },
        {
          text: "من نحن",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      id: this.$route.params.id,
      about: new About,
      acceptFile: appConfig.acceptFile.about,
      aspectRatio: appConfig.aspectRatio.about,
      submitadd: false,
      loadingButton: false,
      loadingContent: false
    };
  },
  // vuelidate
  validations: {
    about: {
      title_ar: {required, minLength: minLength(2), maxLength: maxLength(300) },
      title_en: {required, minLength: minLength(2), maxLength: maxLength(300) },
      title_fa: {required, minLength: minLength(2), maxLength: maxLength(300) },
      locales: {required}
    },
  },
  computed:{
    ...mapGetters('about', ['getAbout'])
  },
  methods: {
    ...mapActions("about", ['getAll', 'edit']),
    imageError,
    handleError(error){
      alert(error)
      if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
      else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    chnageFile(e){
      this.about.Image = e.target.files.length > 0 ? e.target.files[0] : null
    },
    setCroppedImage(){
      const result = this.$refs.cropper.getResult();
      const data64 = result.canvas.toDataURL(this.about.ImageType);
      this.about.image = dataURLtoFile(data64, this.about.ImageName);
    },
    getEditorImages(){
      return [...this.$refs.editor1.$data.images, ...this.$refs.editor2.$data.images, ...this.$refs.editor3.$data.images]
    },
    resetForm(){
      this.submitadd = false
      this.loadingButton = false
      this.errors = []
    },
    checkLocale(locale){
      return this.about.locales.includes(locale);
    },
    formEditAbout() {
      this.submitadd = true;
      this.$v.$touch();
      if(this.$v.error) return;

      // to form submit after this
      this.loadingButton = true
      this.errors = [];

      this.about.editor_images = this.getEditorImages()

      if(this.about.picture != '')
        this.setCroppedImage()

      this.edit({
        id: this.about.id,
        about: this.about.toFormData()
      }).then((response)=>{
        swal.success(response.data.message)
        this.resetForm()
      })
      .catch((error)=>{
        alert(error)
        this.handleError(error)
        this.loadingButton = false
      })
    },
  },
  created(){
    this.getAll()
    .then(()=>{
      this.about = this.getAbout
      this.loadingContent = true
    })
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">

            <b-form v-if="loadingContent" @submit.prevent="formEditAbout()">

              <AlertError :errors="errors"></AlertError>

              <div class="row mt-3">

                <b-form-group class="col-md-12 mb-3 class_ar" label="العنوان : ( عربي )" label-for="title_ar" >
                  <b-form-input id="title_ar" v-model.trim="about.title_ar" :class="{ 'is-invalid': submitadd && $v.about.title_ar.$error }" placeholder="ادخل عنوان الخبر" type="text" ></b-form-input>
                  <div v-if="submitadd && $v.about.title_ar.$error" class="invalid-feedback">
                    <span v-if="!$v.about.title_ar.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.about.title_ar.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
                    <span v-if="!$v.about.title_ar.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group class="col-md-12 mb-3 class_en" label="العنوان : ( انجليزي )" label-for="title-en" >
                  <b-form-input id="title-en" v-model.trim="about.title_en" :class="{ 'is-invalid': submitadd && $v.about.title_en.$error }" placeholder="ادخل عنوان الخبر" type="text" ></b-form-input>
                  <div v-if="submitadd && $v.about.title_en.$error" class="invalid-feedback">
                    <span v-if="!$v.about.title_en.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.about.title_en.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
                    <span v-if="!$v.about.title_en.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group class="col-md-12 mb-3 class_fa" label="العنوان : ( فارسي )" label-for="title-fa" >
                  <b-form-input id="title-fa" v-model.trim="about.title_fa" :class="{ 'is-invalid': submitadd && $v.about.title_fa.$error }" placeholder="ادخل عنوان الخبر" type="text" ></b-form-input>
                  <div v-if="submitadd && $v.about.title_fa.$error" class="invalid-feedback">
                    <span v-if="!$v.about.title_fa.required"> هذا الحقل الزامي </span>
                    <span v-if="!$v.about.title_fa.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
                    <span v-if="!$v.about.title_fa.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
                  </div>
                </b-form-group>

                <b-form-group class="col-md-12 mb-3" label="الصورة الرئيسية : " label-for="image" >
                  <div class="custom_file">
                    <b-form-file id="image" ref="image" v-model="about.image" :accept="acceptFile" @change="chnageFile" placeholder="اختر صورة" ></b-form-file>
                  </div>
                
                  <b-button v-if="!about.picture" @click="()=>about.picture = about.get_image_url" variant="secondary" type="button" class=" mt-3 mb-3 w-100">تعديل الصورة</b-button>
                  <b-button v-if="about.picture" @click="()=>{$refs.image.reset(); about.picture = '' }" variant="dark" type="button" class=" mt-3 mb-3 w-100">تراجع</b-button>


                  <cropper v-if="about.picture" :src="about.picture" @error="imageError" class="cropper" ref="cropper" :auto-zoom="true"
                    :stencil-props="{ aspectRatio: aspectRatio }"
                  ></cropper>
                </b-form-group>

                <!-- Editor -->
                <b-form-group class="col-md-12 mb-3 class_ar" label=" المحتوى : ( عربي )" label-for="editor1" >
                  <vueEditor id="editor1" ref="editor1" v-model="about.content_ar" />
                </b-form-group>
                <b-form-group class="col-md-12 mb-3 class_en" label=" المحتوى : ( انجليزي )" label-for="editor2" >
                  <vueEditor id="editor2" ref="editor2" v-model="about.content_en" />
                </b-form-group>
                <b-form-group class="col-md-12 mb-3 class_fa" label=" المحتوى : ( فارسي )" label-for="editor3" >
                  <vueEditor id="editor3" ref="editor3" v-model="about.content_fa" />
                </b-form-group>

                <b-form-group class="col-md-12 mb-3" label="الكلمات المفتاحية :" label-for="tag" >
                  <input-tag class="form-control" placeholder="اضافة" :limit="limit" validate="" v-model="about.tags"></input-tag>
                </b-form-group>

              </div>

              <div class="mt-3">
                <hr>
                <b-button :disabled="loadingButton" variant="primary" type="submit" class="me-2"> 
                  <b-spinner v-if="loadingButton" small></b-spinner>
                  <span v-else><i class="bx bx-check font-size-16 align-middle me-2"></i>حفظ التعديلات</span>
                </b-button>
              </div>
            </b-form>
            
            <!-- loading content -->
            <div v-else>
              <vue-content-loading :rtl="true" :width="400" :height="310">
                <rect  x="0" y="4" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="8" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="23" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="27" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="42" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="46" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="61" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="65" rx="1" ry="1" width="400" height="10" />
                <rect x="0" y="77" rx="1" ry="1" width="250" height="70" />
                <rect x="0" y="153" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="157" rx="1" ry="1" width="400" height="35" />
                <rect x="0" y="198" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="202" rx="1" ry="1" width="400" height="35" />
                <rect x="0" y="243" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="247" rx="1" ry="1" width="400" height="35" />
                <rect x="0" y="290" rx="1" ry="1" width="400" height="1" />
                <rect x="0" y="295" rx="1" ry="1" width="35" height="10" />
              </vue-content-loading>
            </div>

          </div>
        </div>
      </div>

    </div>

  </Layout>
</template>